import PropTypes from 'prop-types'
import React from 'react'
import DestinationsField from '../containers/destinations_field'
import SelectionSummary from '../containers/selection_summary'
import Selector from '../containers/selector'

const App = ({ className, buttonClassName, summaryClassName, recruiterIds, tagIds, specialTypes, onChange }) => (
  <div className={className}>
    <Selector
      buttonClassName={buttonClassName}
      recruiterIds={recruiterIds}
      tagIds={tagIds}
      specialTypes={specialTypes}
      onChange={onChange}
    />
    <SelectionSummary
      className={summaryClassName}
      recruiterIds={recruiterIds}
      tagIds={tagIds}
      specialTypes={specialTypes}
    />
    <DestinationsField recruiterIds={recruiterIds} tagIds={tagIds} specialTypes={specialTypes} />
  </div>
)

App.propTypes = {
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  summaryClassName: PropTypes.string,
  recruiterIds: PropTypes.arrayOf(PropTypes.number),
  tagIds: PropTypes.arrayOf(PropTypes.number),
  specialTypes: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired
}

App.defaultProps = {
  className: null,
  buttonClassName: null,
  summaryClassName: null,
  recruiterIds: [],
  tagIds: [],
  specialTypes: []
}

export default App
